import template from './lifts.jade';
import { getLiftTypesByCategory } from '../../../enums/lift-types';
import validation from '../../../services/validation';

export default angular.module('cian.addForm.lifts', []).directive('cianAfAboutObjectLifts', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'deviceService',
    function (deviceService) {
      this.isMobile = deviceService.isMobile;
      this.ad.building = this.ad.building || {};
      this.ad.building.liftTypes = this.ad.building.liftTypes || [];

      const items = getLiftTypesByCategory(this.ad.category).map((item, index) => {
        return {
          ...item,
          inputName: `building.liftTypes.${index}`,
        };
      });

      this.items = items.map(originalItem => {
        const item = { ...originalItem };
        const itemType = item.value;
        const itemInModel =
          this.ad.building.liftTypes.find(item => item.type === itemType) ||
          (this.ad.building.liftTypes.push({ type: itemType }) &&
            this.ad.building.liftTypes[this.ad.building.liftTypes.length - 1]);
        Object.defineProperty(item, 'count', {
          get() {
            return itemInModel.count;
          },
          set(value) {
            itemInModel.count = value;
          },
        });

        Object.defineProperty(item, 'loadCapacity', {
          get() {
            return itemInModel.loadCapacity;
          },
          set(value) {
            itemInModel.loadCapacity = value;
          },
        });

        item.validation = validation(this.form, item.inputName + '.count', {
          parse: 'Введите число',
          min: 'Введите число',
          maxlength: 'Введите число',
          max: 'Допустимо не более 2 символов',
        });

        item.validationCapacity = validation(this.form, item.inputName + '.loadCapacity', {
          parse: 'Введите число',
          min: 'Введите число',
          maxlength: 'Введите число',
          max: 'Допустимо не более 3 символов',
        });

        return item;
      });

      this.minCount = 0;
      this.maxCount = 999;

      this.onCountChange = lift => {
        if (!lift.count) {
          lift.loadCapacity = null;
        }
      };
    },
  ],
  controllerAs: 'lifts',
  template,
})).name;
